/**
 * Signup ekranındaki zorunlu onay metinleri.
 * Kullanıcı ilgili metnin adına tıkladığında sözleşme/aydınlatma metni bir
 * modal içinde (kaydırılabilir) görüntülenir. İçerikler ekteki resmi
 * dokümanlarla (Üyelik ve Kullanım Sözleşmesi, KVKK Aydınlatma Metni,
 * Gizlilik ve Çerez Politikası) birebir uyumludur.
 */
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";

function H({ children }) {
  return <h3 className="font-display font-bold text-base tracking-tight mt-4 mb-1">{children}</h3>;
}
function P({ children }) {
  return <p className="text-sm text-muted-foreground leading-relaxed mb-2">{children}</p>;
}
function UL({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1 text-sm text-muted-foreground mb-2">
      {items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}

function MembershipDoc() {
  return (
    <div data-testid="doc-membership">
      <P><strong>Son Güncelleme Tarihi:</strong> 06.07.2026</P>
      <P>
        Bu Üyelik ve Kullanım Sözleşmesi (“Sözleşme”), Esnek Yazılım ve Teknoloji Hizmetleri
        (Esnek Yazılım) tarafından sunulan Lastik Oteli Yönetim Sistemi hizmetinden yararlanan
        kullanıcı (“Kullanıcı”) ile Esnek Yazılım (“Hizmet Sağlayıcı”) arasında elektronik
        ortamda kurulmuştur.
      </P>
      <H>1. Taraflar</H>
      <P>
        İşbu sözleşme; Hizmet Sağlayıcı Esnek Yazılım ile Kullanıcı sisteme üye olan gerçek veya
        tüzel kişi (“Kullanıcı”) arasında akdedilmiştir.
      </P>
      <H>2. Hizmetin Konusu</H>
      <P>Lastik Oteli Yönetim Sistemi;</P>
      <UL items={[
        "Müşteri yönetimi",
        "Araç kayıtları",
        "Lastik seti yönetimi",
        "Depo ve raf yönetimi",
        "Barkod sistemi",
        "Cari hesap takibi",
        "Raporlama",
        "Hatırlatma hizmetleri",
        "Diğer yönetim modüllerinin internet üzerinden kullanılmasını sağlayan bulut tabanlı bir yazılımdır.",
      ]} />
      <H>3. Üyelik</H>
      <P>Sisteme kayıt olan kullanıcı;</P>
      <UL items={[
        "verdiği bilgilerin doğru olduğunu,",
        "güncel tutulacağını,",
        "hesabın güvenliğinden sorumlu olduğunu kabul eder.",
      ]} />
      <P>Şifre güvenliği tamamen kullanıcıya aittir.</P>
      <H>4. Ücretsiz Deneme</H>
      <P>
        Yeni oluşturulan hesaplara Esnek Yazılım tarafından belirlenen süre boyunca ücretsiz
        deneme hakkı tanımlanabilir. Deneme süresi sonunda; hesap ücretli plana geçirilebilir,
        hizmet durdurulabilir veya Esnek Yazılım tarafından belirlenen başka bir uygulama
        yapılabilir.
      </P>
      <H>5. Abonelik</H>
      <P>
        Hizmet aylık veya yıllık abonelik modeli ile sunulur. Abonelik; seçilen plana göre
        ücretlendirilir. Kullanıcı istediği zaman planını yükseltebilir veya düşürebilir.
      </P>
      <H>6. Ödeme</H>
      <P>
        Abonelik ücretleri; peşin tahsil edilir. Karşılığında fatura düzenlenir. Ödemesi
        yapılmayan aboneliklerde Esnek Yazılım; hizmeti askıya alabilir, kullanıcı erişimini
        durdurabilir.
      </P>
      <H>7. Kullanıcı Verileri</H>
      <P>
        Sisteme girilen; müşteri bilgileri, araç bilgileri, lastik bilgileri, cari hesap
        kayıtları, raporlar kullanıcının mülkiyetindedir. Esnek Yazılım bu verileri; satmaz,
        üçüncü kişilerle paylaşmaz, yalnızca hizmetin sunulması amacıyla işler. Yasal
        zorunluluklar saklıdır.
      </P>
      <H>8. Veri Güvenliği</H>
      <P>
        Esnek Yazılım; makul güvenlik önlemlerini almayı, düzenli yedekleme yapmayı, altyapısını
        güncel tutmayı hedefler. Ancak; internet kesintileri, veri merkezi arızaları, doğal
        afetler, siber saldırılar gibi mücbir sebeplerden kaynaklanan kesintilerden sorumlu
        tutulamaz. Kullanıcı işletme verilerini belirli sürelerde rapor alarak yedekleyebilir;
        Esnek Yazılım, olası veri kayıplarından hiçbir şekilde sorumlu tutulamaz.
      </P>
      <H>9. WhatsApp Bildirimleri</H>
      <P>
        Kullanıcı; müşterilerine gönderilecek WhatsApp bildirimlerinden ve ilgili mevzuata uygun
        izinlerin alınmasından kendisi sorumludur. Esnek Yazılım yalnızca teknik altyapıyı sağlar.
      </P>
      <H>10. Yasak Kullanımlar</H>
      <P>
        Kullanıcı; sistemi hukuka aykırı amaçlarla kullanamaz, sisteme zarar verecek girişimlerde
        bulunamaz, başka kullanıcıların hesaplarına erişmeye çalışamaz, kaynak kodunu kopyalayamaz,
        sistemi tersine mühendislik yöntemiyle inceleyemez.
      </P>
      <H>11. Fikri Mülkiyet</H>
      <P>
        Yazılımın; kaynak kodu, tasarımı, logoları, arayüzleri, algoritmaları Esnek Yazılım’a
        aittir. Kullanıcı yalnızca kullanım hakkına sahiptir.
      </P>
      <H>12. Hizmetin Kesintiye Uğraması</H>
      <P>
        Bakım çalışmaları, güncellemeler veya teknik nedenlerle hizmette geçici kesintiler
        yaşanabilir. Esnek Yazılım bu kesintileri en kısa sürede gidermeyi amaçlar.
      </P>
      <H>13. Hesabın Sonlandırılması</H>
      <P>
        Esnek Yazılım; aşağıdaki durumlarda üyeliği sonlandırabilir: ödeme yapılmaması, hukuka
        aykırı kullanım, sisteme zarar verme girişimi, sözleşmenin ihlali.
      </P>
      <H>14. Veri Silme</H>
      <P>
        Aboneliğin sona ermesinden sonra; Esnek Yazılım kullanıcı verilerini belirli bir süre
        saklayabilir. Bu sürenin sonunda veriler kalıcı olarak silinebilir.
      </P>
      <H>15. Sorumluluğun Sınırlandırılması</H>
      <P>
        Esnek Yazılım; dolaylı zararlar, kar kaybı, iş kaybı, veri kaybı, müşteri kaybı gibi
        sonuçlardan sorumlu tutulamaz. Toplam sorumluluk, kullanıcının son 12 ay içinde ödediği
        abonelik bedeli ile sınırlıdır.
      </P>
      <H>16. Gizlilik</H>
      <P>Kullanıcı verileri, Gizlilik Politikası kapsamında işlenmektedir.</P>
      <H>17. Değişiklik</H>
      <P>
        Esnek Yazılım bu sözleşmede değişiklik yapabilir. Güncel sözleşme uygulamada veya internet
        sitesinde yayımlandığı tarihten itibaren geçerlidir.
      </P>
      <H>18. Uygulanacak Hukuk</H>
      <P>
        İşbu sözleşmede Türkiye Cumhuriyeti Hukuku uygulanacaktır. Uyuşmazlıklarda Ankara
        Mahkemeleri ve İcra Daireleri yetkilidir.
      </P>
      <H>19. Yürürlük</H>
      <P>
        Kullanıcı; “Üye Ol” butonuna tıklayarak işbu sözleşmeyi okuduğunu, anladığını ve kabul
        ettiğini beyan eder.
      </P>
    </div>
  );
}

function KvkkDoc() {
  return (
    <div data-testid="doc-kvkk">
      <P>
        6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında veri sorumlusu Esnek Yazılım’dır.
      </P>
      <H>İşlenen Veriler</H>
      <UL items={[
        "Kimlik Bilgileri",
        "İletişim Bilgileri",
        "Firma Bilgileri",
        "Araç Bilgileri",
        "Müşteri Bilgileri",
        "İşlem Kayıtları",
        "Finansal Bilgiler",
      ]} />
      <H>İşleme Amaçları</H>
      <P>Kişisel veriler;</P>
      <UL items={[
        "Hizmet sunulması",
        "Destek verilmesi",
        "Fatura düzenlenmesi",
        "Yasal yükümlülüklerin yerine getirilmesi",
        "Bilgi güvenliğinin sağlanması",
      ]} />
      <P>amacıyla işlenmektedir.</P>
      <H>Hukuki Sebep</H>
      <P>KVKK’nın 5 ve 6. maddeleri kapsamında;</P>
      <UL items={[
        "Sözleşmenin kurulması",
        "Kanuni yükümlülükler",
        "Meşru menfaat",
      ]} />
      <P>hukuki sebeplerine dayanılarak işlenmektedir.</P>
      <H>Haklarınız</H>
      <P>KVKK’nın 11. maddesi gereğince;</P>
      <UL items={[
        "Verilerinizin işlenip işlenmediğini öğrenme,",
        "Düzeltme isteme,",
        "Silinmesini isteme,",
        "Aktarılmasını isteme,",
        "İtiraz etme",
      ]} />
      <P>haklarına sahipsiniz.</P>
      <P>Başvurularınızı; info@esnekyazilim.com.tr adresine iletebilirsiniz.</P>
    </div>
  );
}

function PrivacyDoc() {
  return (
    <div data-testid="doc-privacy">
      <P><strong>Son Güncelleme Tarihi:</strong> 06.07.2026</P>
      <P>Esnek Yazılım olarak kullanıcılarımızın kişisel verilerinin gizliliğine önem veriyoruz.</P>
      <P>
        Bu politika, Lastik Oteli Yönetim Sistemi’ni kullanan kullanıcıların bilgilerinin hangi
        amaçlarla toplandığını ve nasıl korunduğunu açıklamaktadır.
      </P>
      <H>Toplanan Veriler</H>
      <P>Hizmet kapsamında aşağıdaki bilgiler işlenebilir:</P>
      <UL items={[
        "Ad Soyad",
        "Firma Unvanı",
        "Vergi Bilgileri",
        "Telefon",
        "E-posta",
        "Araç Bilgileri",
        "Müşteri Bilgileri",
        "Lastik Bilgileri",
        "İşlem Kayıtları",
        "Ödeme Bilgileri",
      ]} />
      <H>Kullanım Amaçları</H>
      <P>Toplanan bilgiler;</P>
      <UL items={[
        "Hizmetin sunulması",
        "Teknik destek sağlanması",
        "Faturalandırma",
        "Güvenlik",
        "Sistem geliştirme",
        "Yasal yükümlülüklerin yerine getirilmesi",
      ]} />
      <P>amaçlarıyla kullanılmaktadır.</P>
      <H>Veri Güvenliği</H>
      <P>
        Veriler modern güvenlik standartları kullanılarak korunmaktadır. Yetkisiz erişimi önlemek
        amacıyla gerekli teknik ve idari tedbirler alınmaktadır.
      </P>
      <H>Üçüncü Taraflar</H>
      <P>Kullanıcı verileri;</P>
      <UL items={[
        "Kanuni zorunluluklar dışında,",
        "Kullanıcının açık rızası olmadan,",
      ]} />
      <P>üçüncü kişilerle paylaşılmaz.</P>
      <H>Saklama Süresi</H>
      <P>Veriler yürürlükteki mevzuata uygun süre boyunca saklanmaktadır.</P>
      <H>İletişim</H>
      <P>Sorularınız için e-posta: info@esnekyazilim.com.tr</P>

      <H>Çerez Politikası</H>
      <P>
        Lastik Oteli Yönetim Sistemi, kullanıcı deneyimini geliştirmek amacıyla çerezler (cookies)
        kullanmaktadır.
      </P>
      <H>Çerez Nedir?</H>
      <P>Çerezler, internet tarayıcınız tarafından cihazınıza kaydedilen küçük metin dosyalarıdır.</P>
      <H>Kullanılan Çerezler</H>
      <UL items={[
        "Oturum Çerezleri",
        "Güvenlik Çerezleri",
        "Tercih Çerezleri",
        "Analitik Çerezler",
      ]} />
      <H>Çerezlerin Kullanım Amacı</H>
      <UL items={[
        "Oturumun açık tutulması",
        "Güvenli giriş sağlanması",
        "Kullanıcı tercihleri",
        "Performans analizi",
        "Hizmet kalitesinin artırılması",
      ]} />
      <H>Çerez Yönetimi</H>
      <P>
        Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz. Bazı çerezlerin devre
        dışı bırakılması hizmetin bazı özelliklerinin çalışmamasına neden olabilir.
      </P>
    </div>
  );
}

const DOCS = {
  membership: { title: "Üyelik ve Kullanım Sözleşmesi", Body: MembershipDoc },
  kvkk: { title: "KVKK Aydınlatma Metni", Body: KvkkDoc },
  privacy: { title: "Gizlilik Politikası ve Çerez Politikası", Body: PrivacyDoc },
};

/**
 * Metin adı olarak render edilen tıklanabilir bağlantı; tıklanınca ilgili
 * dokümanı modal içinde açar. `doc` prop'u DOCS anahtarlarından biridir.
 */
export default function LegalDocLink({ doc, children, className = "" }) {
  const [open, setOpen] = useState(false);
  const entry = DOCS[doc];
  if (!entry) return <>{children}</>;
  const { title, Body } = entry;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`underline font-medium text-foreground hover:text-amber-600 ${className}`}
        data-testid={`legal-link-${doc}`}
      >
        {children}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl rounded-sm">
          <DialogHeader>
            <DialogTitle className="font-display font-black tracking-tight">{title}</DialogTitle>
          </DialogHeader>
          <ScrollArea className="max-h-[70vh] pr-4">
            <Body />
          </ScrollArea>
        </DialogContent>
      </Dialog>
    </>
  );
}
